<template>
  <div style="margin-top:15px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <!--<el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="所属机构" prop="partyGroupCode" style="margin-right:15px">
              <el-select v-model="form.partyGroupCode" placeholder="请选择机构" clearable style="width: 100%">
                <el-option
                  v-for="item in partyGroup"
                  :key="item.code"
                  :label="item.groupName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>-->

      <el-row>
        <el-form-item label="客户名称" prop="shipmentCode" style="margin-right:15px">
          <shipmentSelect ref="shipmentSelect" @setCustomerCode="setCustomerCode" />
        </el-form-item>
        <el-form-item label="计费类型" prop="chargingType" style="margin-right:15px">
          <costTypeSelect ref="costType" @queryCostType="selectCostType" />
        </el-form-item>
        <el-form-item label="单价" prop="price" style="margin-right:15px">
          <el-input v-model="form.price" placeholder="请输入单价" />
        </el-form-item>
        <el-form-item label="计费方式" prop="chargingMode" style="margin-right:15px">
          <el-select v-model="form.chargingMode" placeholder="请选择">
            <el-option value="1" label="吨" />
          </el-select>
        </el-form-item>
        <el-form-item label="有效期" prop="validityDate" min-width="350" style="margin-right:15px">
          <el-date-picker
            v-model="form.validityDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import shipmentSelect from '@/views/components/shipmentSelect.vue'
import costTypeSelect from './costTypeSelect.vue'
export default {
  name: 'ChargingTypeAdd',
  components: {
    costTypeSelect,
    shipmentSelect
  },
  data() {
    return {
      validityDate: '',
      loading: false,
      cascadeData: [],
      emptyForm: {},
      form: {
        code: '',
        shipmentCode: '',
        shipmentName:'',
        partyGroupCode:'',
        chargingType: '',
        sysType: '',
        price: '',
        chargingMode: '',
        startDate: '',
        validityDate: '',
        endDate: ''
      },
      partyGroup:[],

      rules: {
        partyGroupCode: [
          { required: true, message: '请选择所属机构', trigger: 'blur' }
        ],

        shipmentCode: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        chargingType: [
          { required: true, message: '请选择计费类型', trigger: 'blur' }
        ],
        sysType: [
          { required: true, message: '请输入系统类型', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入单价', trigger: 'blur' }

        ],
        chargingMode: [
          { required: true, message: '请选择计费方式', trigger: 'blur' }
        ],
        validityDate: [
          { required: true, message: '请输入有效期', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 选择客户
    setCustomerCode(value) {
      this.form.shipmentCode = value.code;
      this.form.shipmentName = value.name
    },
    // 选择计费类型
    selectCostType(value) {
      this.form.chargingType = value[1]
      this.form.sysType = value[0]
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.startDate = this.form.validityDate[0]
          this.form.endDate = this.form.validityDate[1]
          const data = this.form
          const rLoading = this.openLoading();
          request({ url: '/ntocc-basic-api/chargingType', method: 'post', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => {
            this.$refs['form'].resetFields()
            this.$refs.shipmentSelect.setSelectValue('')
            this.$refs.costType.setSelectValue('')
          })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
